import React, {useState, Suspense} from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from 'utils/CommonUtil';
import DateUtil from "utils/DateUtil";
import UISunEditor from "components/wysiwygeditor/UISunEditor";
import PageLoading from "../../../../components/loading";
import TbComFile from "domain/main/com/file/TbComFile";
import UI from "components/UI";
import TbComFileMapngDetail from "../../../../domain/main/com/file/mapng/TbComFileMapngDetail";


function ContentsContainer() {
	const history = useHistory();
	const location = useLocation();
	const receivedData = (location.state as any)?.data;
	const [demandDetail, setDemanDetail] = useState<any>([]);
	const demandNo = receivedData?.DEMAND_NO;
	const seq = receivedData?.SEQ;
	const [reqDate, setReqDate] = useState('');
	const [writeUserNm, setWriteUserNm] = useState('');

	// 파일
	const [fileValue] = useState(new TbComFile());
	const [reqFileValue] = useState(new TbComFile());
	const [loadFinish,setLoadFinish] = useState(false);
	const [reqFileNm, setReqFileNm] = useState('');

	function dateLpad(num){
		if(num.toString().length == 1){
			num = "0"+num;
		}

		return num;
	}

	function dateToStr(dateText) {

		if(dateText == null) return '';

		if(/^(-?)[0-9]+$/.test(dateText)){
			dateText = Number(dateText);
		}
		let date = new Date(dateText);
		let week = new Array('일', '월', '화', '수', '목', '금', '토');


		let year = date.getFullYear();
		let month = date.getMonth()+1;
		let day = date.getDate();
		let dayName = week[date.getDay()];

		return year+'-'+dateLpad(month)+'-'+dateLpad(day)+'('+dayName+')';
	}

	async function getRead() {

		const response:any = await CommonUtil.execute({
			url: 'usr_1909',
			data: {DEMAND_NO: demandNo,
					SEQ : seq,
			}
		}).then((response: any) => {
			setDemanDetail(response);
			setWriteUserNm(response.WRITE_USERNM);
			setReqDate(dateToStr(response.REQ_DATE));

			fileValue.setTbComFileMapngDetailList([]);
			reqFileValue.setTbComFileMapngDetailList([]);
			let fileList = response.FILE_INFO;
			for(let i = 0; i < fileList.length; i++){
				if(fileList[i].FILE_GB == 'FILE'){
					let fileInfo = fileList[i];

					//파일등록 정보
					const fileDetail = new TbComFileMapngDetail();
					fileDetail.setDwldId(fileInfo.DWLD_ID);
					fileDetail.setFileDetailId(fileInfo.FILE_DETAIL_ID);
					fileDetail.setFilePolicy(fileInfo.FILE_POLICY);
					fileDetail.setFileRpstr(fileInfo.FILE_RPSTR);
					fileDetail.setStrePath(fileInfo.STRE_PATH);
					fileDetail.setStreFileNm(fileInfo.STRE_FILE_NM);
					fileDetail.setOrginlFileNm(fileInfo.ORGINL_FILE_NM);
					fileDetail.setFileExtsn(fileInfo.FILE_EXTSN);
					fileDetail.setFileSize(fileInfo.FILE_SIZE);
					fileDetail.setRegistPsnNm(fileInfo.REGIST_PSN_NM);
					fileDetail.setRegistDt(fileInfo.REGIST_DT);
					fileValue.putTbComFileMapngDetailList(fileDetail);
				} else if(fileList[i].FILE_GB == 'REQ'){
					let fileInfo = fileList[i];

					//파일등록 정보
					const fileDetail = new TbComFileMapngDetail();
					fileDetail.setDwldId(fileInfo.DWLD_ID);
					fileDetail.setFileDetailId(fileInfo.FILE_DETAIL_ID);
					fileDetail.setFilePolicy(fileInfo.FILE_POLICY);
					fileDetail.setFileRpstr(fileInfo.FILE_RPSTR);
					fileDetail.setStrePath(fileInfo.STRE_PATH);
					fileDetail.setStreFileNm(fileInfo.STRE_FILE_NM);
					fileDetail.setOrginlFileNm(fileInfo.ORGINL_FILE_NM);
					fileDetail.setFileExtsn(fileInfo.FILE_EXTSN);
					fileDetail.setFileSize(fileInfo.FILE_SIZE);
					fileDetail.setRegistPsnNm(fileInfo.REGIST_PSN_NM);
					fileDetail.setRegistDt(fileInfo.REGIST_DT);
					reqFileValue.putTbComFileMapngDetailList(fileDetail);
					setReqFileNm(fileInfo.ORGINL_FILE_NM);
				}
			}

			setLoadFinish(true);
		}).catch((error) => {
			CommonUtil.showAxiosError(error);
			return;
		});
	}

	React.useEffect(() => {
		getRead();
	}, []);//effect

	async function editDemandReq() {
		let dataToSend = {DEMAND_NO : demandNo , SEQ : seq}
		history.push({
			pathname: './usr_1910',
			state: {data: dataToSend}
		});
	}


	return (
		<PageContainer session={false}>
			<LayoutAside />
			<div className='fww-con'>
				<ul className="fww-brd">
					<li><Link to="/main/">홈</Link></li>
					<li><Link to="#">상생협력기금안내</Link></li>
					<li><Link to="#">수요조사</Link></li>
				</ul>
				<main className="fww-main" data-layout="usr">
					<h1 className="tx tx-hd2">수요조사 지원 내용</h1>
					<section className="fund-section">
						<div className="hz-root hz-gap10 hz-sb mb15">
							<h3 className="section-title">기본정보</h3>
						</div>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item req">
									<p className="fo-key">수요조사지원일</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={reqDate} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">신청기업명</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={demandDetail.CORP_NM} placeholder={'기업명을 입력하세요.'} readOnly={true}/>
									</div>
								</div>
								
								<div className="fo-item req">
									<p className="fo-key">담당자명</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={demandDetail.PERSON_NM} placeholder={'담당자명을 입력하세요'} readOnly={true}/>
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">직함</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={demandDetail.POSI_NM} placeholder={'직함을 입력하세요'} readOnly={true}/>
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">연락처</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={demandDetail.OFC_TEL_NO} placeholder={'연락처를 입력하세요(- 생략)'} readOnly={true}/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">휴대폰번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={demandDetail.HP_NO} placeholder={'휴대폰번호를 입력하세요(- 생략)'}  readOnly={true}/>
									</div>
								</div>
								<div className="fo-item  fo-m-1-3 req">
									<p className="fo-key">이메일주소</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={demandDetail.EMAIL_ADRES} placeholder={''}  readOnly={true}/>
									</div>
								</div>
							</div>
						</form>
					</section>
					<section className="fund-section">
						<h3 className="section-title mb15">신청 정보</h3>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="innter">
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">신청제목</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={demandDetail.REQ_TITLE} placeholder={'신청제목을 입력하세요.'} readOnly={true} />
									</div>
								</div>
								<div className="fo-item fo-m-1-3">
									<p className="fo-key">상생협력기금 사용여부</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={demandDetail.FUN_USE_YN == 'Y' ? '사용' : '미사용'} placeholder={''} readOnly={true} />
									</div>
								</div>
								{demandDetail.FUN_USE_YN == 'Y' &&
									<div className="fo-item fo-m-1-3">
										<p className="fo-key">금액입력(원)</p>
										<div className="fo-value">
											<div className="fund-form-items tf-unit">
												<UIInput className={'tf tf-md ta-right'} value={Number(demandDetail.FUN_USE_AMT)} placeholder={'상생협력기금으로 사용할 금액을 입력하세요.'} readOnly={true} />
												<span className="u">원</span>
											</div>
										</div>
									</div>
								}
							</div>
						</form>
					</section>
					<section className="fund-section">
						<h3 className="section-title mb15">첨부파일</h3>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="innter">
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">필수서류</p>
									<div className="fo-value">
										<div className="fund-form-group">
											<div className="fund-form-items">
												<div className="hz-root hz-gap5 w100p mr30">
													{/*<UIInput className={'tf tf-md hz-item grow'} value={reqFileNm}
															 placeholder={''} readOnly={true}/>*/}
													<div className="hz-root hz-gap5 w120 ">
														{/* 
														<Button color='pri-o2' size="md">찾기</Button>
														<Button color='gray-o' size="md">삭제</Button>
														 */}
													</div>
												</div>
											</div>
											<UI.FileDownloadSimpleMode value={reqFileValue}
																	   viewMode={"fund-download"}/>
										</div>
									</div>
								</div>
								<div className="tb-view-cont">
									<div className={"w100p"}>
										<UI.FileDownload value={fileValue}/>
									</div>
								</div>
							</div>
						</form>
					</section>
					<div className="fww-signature">
						<span>{demandDetail.TITLE} 공고문을 확인하고, 위와 같이 신청서를 제출하였습니다.</span>
						<strong>대·중소기업·농어업협력재단 사무총장 귀하</strong>
					</div>
					<div className="hz-root hz-center hz-gap10">
						{demandDetail.PERSON_ID === demandDetail.REQ_USERID &&
						 demandDetail.STS_CD === "Y" && /* 2024.10.15 수정버튼 상태값 조건 추가 */
							<Button color="pri" size="big" onClick={() => editDemandReq()}>수정</Button>
						}
						<Button color="gray-o" size="big" href="/main/usr_1900/usr_1907">목록</Button>
					</div>
				</main>
			</div>			
		</PageContainer>
	);
}
export default ContentsContainer;